export default {
    path: '/personnel/personnelAdd',
    name: 'PersonnelAdd',
    component: () => import(/* webpackChunkName: "personnelAdd" */ '../../views/personnel/components/personnelAdd.vue')
}